import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';
import AccessDenied from './AccessDenied';

const RoleBasedRoute = ({ children, allowedRoles, fallbackPath = '/', showAccessDenied = false }) => {
  const { user } = useAuth();

  // If not authenticated, redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated but role not allowed
  if (!allowedRoles.includes(user.role)) {
    // Show access denied page or redirect
    if (showAccessDenied) {
      return <AccessDenied />;
    }
    return <Navigate to={fallbackPath} replace />;
  }

  // If authenticated and role is allowed, render children
  return children;
};

export default RoleBasedRoute;
